/**
 * OAuth helper utilities for handling OAuth in iframe environments
 */

/**
 * Detects if the current page is running inside an iframe
 */
export function isInIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin iframe access throws, so we're in an iframe
    return true;
  }
}

/**
 * Opens OAuth URL, handling iframe environments by opening in new tab
 * @returns true if successful, false if popup was blocked
 */
export function openOAuthUrl(url: string): boolean {
  if (isInIframe()) {
    // In iframe: open in new tab to avoid X-Frame-Options blocks
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    return newWindow !== null;
  } else {
    // Not in iframe: normal redirect
    window.location.assign(url);
    return true;
  }
}
